module.exports = __webpack_public_path__ + "static/media/stukko.1bff8719.jpeg";